---
id: resignation-letter-service-go
title: Resignation letter service
owner: Backend Team
status: Active
lastReviewed: 2026-02-02
visibility: internal
tags:
  - resignation
  - letters
  - transfer
  - microservice
---

## Product Overview

### Who it serves

This microservice supports internal workflows that need to transfer resignation letter records between user accounts.

### Primary workflow

A caller submits a transfer request with old and new user IDs, and the service reassigns all resignation letter documents from the previous owner to the new owner.

### Business rules

Transfers update only resignation letter records found for the old user ID, and the service does not create new documents when none exist.

### Outcomes

Resignation letter records in Firestore are reassigned to the new user, enabling continued access after account or ownership changes.

### Out of scope

Resignation letter creation, editing, and UI delivery are handled by other services.

### API documentation

[Internal API Documentation](https://wiki.rezi.ai/apis/resignation-letter-service-go-api-docs)

## Technical Overview

### Architecture flow

Routes in `apps/micro-services/resignation-letter-service-go/pkg/api/routes/routes.go` expose a transfer endpoint that invokes the transfer service and Firestore repository to update user ownership in bulk.

### Entry points

- The API server runs from `apps/micro-services/resignation-letter-service-go/cmd/resignation-letter/main.go`.
- OpenAPI generation is handled by `apps/micro-services/resignation-letter-service-go/cmd/spec/main.go`.

### Key modules

Transfer logic lives in `apps/micro-services/resignation-letter-service-go/pkg/services/transfers`, while request handling resides in `apps/micro-services/resignation-letter-service-go/pkg/api/controllers`.

### Data sources and sinks

The service reads and updates resignation letter documents in Firestore through `apps/micro-services/resignation-letter-service-go/pkg/repo/firestore`.

### Integrations and side effects

Firebase app and Firestore clients are initialized at startup to support repository access.

### Constraints and risks

The transfer process rewrites ownership fields for every matching document, so mis-specified user IDs can shift access across accounts.

## Changelog

- 2026-02-02: Initial documentation.
